import Vue from 'vue'
import Router from 'vue-router'
import pcIndex from '@/components/pcIndex'
import pcAbout from '@/components/pcAbout'
import pcCooperation from '@/components/pcCooperation'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'pcIndex',
      component: pcIndex
    },
    {
      path: '/pcAbout',
      name: 'pcAbout',
      component: pcAbout
    },
    {
      path: '/pcCooperation',
      name: 'pcCooperation',
      component: pcCooperation
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js